export default __webpack_public_path__ + "static/media/manicureprzed.15d22b4d.jpg";